import { LocalizedListItemText } from 'components/Localization/LocalizedListItemText'
import { ConversionRateController } from 'controllers/Analytics/ConversionRateController'
import { KPI } from 'controllers/Analytics/SalesLeadTimeController'
import { useController } from 'customHooks/useController'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useOrganizationContext } from 'utils/useOrganizationContext'
import { ConversionRateGraph } from '../ConversionRateGraph'
import { DashboardWidget, KPITargetConfiguration } from '../DashboardWidget'
import { KpiFiltersAndTargetConfiguration as DashboardConfiguration } from '../KpiFiltersAndTargetConfiguration'

export const ConversionRateWidget = (
  props: KPITargetConfiguration & {
    onError: (kpi: KPI, message: string) => void
  }
) => {
  const { organizationId } = useOrganizationContext()

  const { controller, loading } = useController(
    () => new ConversionRateController(organizationId, props.value)
  )

  const [conversionRate, setConversionRate] = React.useState(undefined)
  const [targetConversionRate, setTargetConversionRate] = React.useState(
    props.value
  )

  const { t } = useTranslation('common')

  useEffect(() => {
    ;(async () => {
      try {
        const convertionRate = await controller.GetConversionRateData()
        setConversionRate(convertionRate)
      } catch (err) {
        if (err['message'] === 'cancelled') {
          return
        }
        // ErrorMessage('Analytics', err['message'])
        setConversionRate(undefined)
        props.onError(KPI.conversionRate, err['message'])
      }
    })()

    return () => controller.CancelRequests()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [controller])

  return (
    <DashboardWidget
      GraphComponent={
        <ConversionRateGraph
          conversionRate={conversionRate}
          targetConversionRate={targetConversionRate}
        />
      }
      ConfigurationComponent={
        <DashboardConfiguration
          targetValueLabel={t(
            'common:dashboard-conversion-target',
            'target conversion rate'
          )}
          configuration={controller.GetConfiguration()}
          saveConfiguration={async (data) => {
            controller.SetConfiguration(data)
            setConversionRate(await controller.GetConversionRateData())
          }}
          saveTarget={(value, unit) => {
            controller.SetTargetConfiguration(KPI.conversionRate, {
              value,
              unit,
            })
            setTargetConversionRate(value)
          }}
        />
      }
      subtitle={
        <LocalizedListItemText
          primaryTranslationKey={'common:dashboard-conversion-rate-title'}
          primaryTypographyProps={{
            variant: 'h5',
          }}
          secondaryTranslationKey={'common:dashboard-conversion-rate-subtitle'}
        />
      }
      loading={conversionRate === undefined || loading['get-convertion-rate']}
      empty={conversionRate === null}
      onRefresh={async () => {
        setConversionRate(await controller.GetConversionRateData())
      }}
    />
  )
}
